import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
const useForm = (
  formattedIDVerificationList,
  initModel,
  submitCallback,
  validateLength,
  validatePattern,
  countryAndIdTypeValidationPattern
) => {
  const [inputs, setInputs] = useState(initModel);
  const isFormattedID = formattedIDVerificationList?.includes(
    countryAndIdTypeValidationPattern
  );
  const {documentIdValue} = useSelector((state) => {
    return {
      documentIdValue: state.globalReducer?.documentIdValue,
    };
  });
  const handleChange = (e) => {
    e.persist();
    inputs.forEach((i) => {
      if (i.name === e.target.name) {
        i.value = i.type === "checkbox" ? e.target.checked : e.target.value;
        parseInput(i);
        !isFormattedID && validateInput(i);
      }
    });
    setInputs([...inputs]);
  };

  useEffect(() => {
    inputs.forEach((i) => {
      if (i.name === "common-text") {
        i.value = documentIdValue;
        parseInput(i);
        !isFormattedID && validateInput(i);
      }
    });
    setInputs([...inputs]);
  }, [documentIdValue]);

  const handleSubmit = (e) => {
    e && e.preventDefault();
    inputs.forEach((i) => validateInput(i));
    inputs.some((i) => i.alert)
      ? setInputs([...inputs])
      : submitCallback(inputs);
  };

  const parseInput = (input) =>
    (input.value = input.parser ? input.parser(input.value) : input.value);

  const validateInput = (input) => {
    let alert = null;
    input.validators &&
      input.validators.forEach(
        (v) =>
          (alert =
            v.isValid &&
            !v.isValid(
              input.value,
              validateLength,
              validatePattern,
              countryAndIdTypeValidationPattern
            )
              ? v.alert
              : alert)
      );
    input.alert = alert;
  };
  const validateFormattedInput = (formattedID) => {
    let alert = null;
    inputs[0]?.validators &&
      inputs[0]?.validators.forEach(
        (v) =>
          (alert =
            v.isValid &&
            !v.isValid(
              formattedID,
              validateLength,
              validatePattern,
              countryAndIdTypeValidationPattern
            )
              ? v.alert
              : alert)
      );
    inputs[0].alert = alert;
    setInputs([...inputs]);
    return !alert ? true : false;
  };

  return [inputs, handleChange, handleSubmit, validateFormattedInput];
};
export default useForm;
